import {ERROR_CODES} from "./errorCodes";

export const MESSAGE_EVENTS = {
    "MESSAGE_CLOSE": "message_close",
    "MESSAGE_CLOSE_GAME": "message_close_game",
    "SWITCH_TO_REAL": "switch_to_real",
    "SWITCH_TO_FREESPINS": "switch_to_freespins",
    "OPEN_HISTORY": "open_history",
};

export const MESSAGE_TYPES = {
    "OK": "ok",
    "INFO": "info",
    "YES_NO": "yes_no",
    "ERROR": "error",
    "WARNING": "warning",
    "COOLDOWN": "cooldown",
    "FREESPINS": "freespins"
};

export const errorMessages = {

    [ERROR_CODES.SERVICE_UNAVAILABLE]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: {"$translate": "service_unavailable"},
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
            }
        }
    },

    [ERROR_CODES.GAME_RUNNING]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$default": "Round running" },
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.GAME_NOT_ENOUGH_CREDIT]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: {"$translate": "not_enough_credit"},
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
                msg: { cs: "OK" }
            }
        }
    },

    [ERROR_CODES.CONNECTION_TIMEOUT]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "connection_timeout" }
        }
    },

    [ERROR_CODES.INTERNAL_SERVER_ERROR]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "internal_server_error" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.UNDEFINED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "internal_server_error" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.ERROR]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "internal_server_error" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.REG_TIME_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: {"$translate": "reg_time_limit"}
        },
        buttons: {
            no: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
                msg: {"$translate": "continue"}
            },
            yes: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: {"$translate": "close_game"}
            }
        }
    },

    [ERROR_CODES.GAME_NOT_FOUND]: {
        type: MESSAGE_TYPES.ERROR,
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.SESSION_NOT_FOUND]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "game_closed" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.SESSION_CLOSED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "session_closed" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.ROUND_ENDED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "round_ended" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.INSUFFICIENT_CREDIT]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "not_enough_credit" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.WALLET_AUTH_FAILED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_auth_failed" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.WALLET_SERVER_EXC]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_server_exc" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.WALLET_BLOCKS_BET]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_blocks_bet" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
            }
        }
    },

    [ERROR_CODES.WALLET_BLOCKS_WIN]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_blocks_win" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
            }
        }
    },

    [ERROR_CODES.WALLET_CANCEL_DUPLICATE]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "wallet_cancel_duplicate" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.PLAYER_LIMIT_EXCEEDED]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "player_limit_exceeded" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.WALLET_BLOCKS_PLAYER]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_blocks_player" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.WALLET_CLOSED_GAME]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_closed_game" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.DAILY_LOSS_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "daily_loss_title" }
        },
        content: {
            msg: { "$translate": "daily_loss_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.MONTH_LOSS_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "month_loss_title" }
        },
        content: {
            msg: { "$translate": "month_loss_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.WEEK_LOSS_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "week_loss_title" }
        },
        content: {
            msg: { "$translate": "week_loss_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.DAILY_BET_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "daily_bet_title" }
        },
        content: {
            msg: { "$translate": "daily_bet_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.WEEKLY_BET_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "week_bet_title" }
        },
        content: {
            msg: { "$translate": "week_bet_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.MONTHLY_BET_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "month_bet_title" }
        },
        content: {
            msg: { "$translate": "month_bet_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.MORE_WINDOWS_OPENED]: {
        type: MESSAGE_TYPES.ERROR,
        title: {
            msg: { "$translate": "more_windows_title" }
        },
        content: {
            msg: { "$translate": "more_windows_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.COOLDOWN]: {
        type: MESSAGE_TYPES.COOLDOWN,
        title: {
            msg: { "$translate": "cooldown_title" }
        },
        content: {
            msg: { "$translate": "cooldown_msg" }
        }
    },

    [ERROR_CODES.LIMIT_IS_MISSING]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "limit_is_missing" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.WITHDRAW_LIMIT]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "withdraw_limit" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.LEGISLATION_NOT_SUPPORTED]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "legislation_not_supported_title" }
        },
        content: {
            msg: { "$translate": "legislation_not_supported_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.PLAYTIME_LIMIT]: {
        type: MESSAGE_TYPES.ERROR,
        title: {
            msg: { "$translate": "playtime_limit_title" }
        },
        content: {
            msg: { "$translate": "playtime_limit_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.HOUR_LOSS_LIMIT]: {
        type: MESSAGE_TYPES.WARNING,
        title: {
            msg: { "$translate": "hour_loss_title" }
        },
        content: {
            msg: { "$translate": "hour_loss_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE,
            }
        }
    },

    [ERROR_CODES.WALLET_OUT_OF_SYNC]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "wallet_out_of_sync" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.INCOMPATIBLE_WALLET_API]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "incompatible_wallet_api" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "close_game" }
            }
        }
    },

    [ERROR_CODES.BET_ROLLED_BACK]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "bet_rolled_back" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.BET_ROLLED_BACK_FATAL]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "bet_rolled_back_fatal" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.CZECH_REGULATION]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: { "$translate": "czech_regulation" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.PLAYTECH_ERROR_CRITICAL]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: {
                cs: ""
            }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME
            }
        }
    },

    [ERROR_CODES.PLAYTECH_ERROR]: {
        type: MESSAGE_TYPES.WARNING,
        content: {
            msg: {
                cs: ""
            }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.GAME_NOT_ENABLED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "game_not_enabled" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE
            }
        }
    },

    [ERROR_CODES.PLAYER_SELF_EXCLUDED]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "player_self_excluded" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME
            }
        }
    },

    [ERROR_CODES.ANOTHER_GAME_OPEN]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "more_windows_msg" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME
            }
        }
    },
    [ERROR_CODES.BAD_REQUEST]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "bad_request" }
        },
        buttons: {
            ok: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME
            }
        }
    },
    [ERROR_CODES.FREESPINS_EXPIRED]: {
        type: MESSAGE_TYPES.FREESPINS,
        content: {
            msg: { "$translate": "free_spins_expired" }
        },
        buttons: {
            yes: {
                event: MESSAGE_EVENTS.SWITCH_TO_REAL,
                msg: { "$translate": "freespins_changed_real_money" }
            },
            no: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "freespins_changed_close" }
            }
        }
    },
    [ERROR_CODES.FREESPINS_ALREADY_REDEEMED]: {
        type: MESSAGE_TYPES.FREESPINS,
        content: {
            msg: { "$translate": "free_spins_already_redeemed" }
        },
        buttons: {
            yes: {
                event: MESSAGE_EVENTS.SWITCH_TO_REAL,
                msg: { "$translate": "freespins_changed_real_money" }
            },
            no: {
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME,
                msg: { "$translate": "freespins_changed_close" }
            }
        }
    },
    [ERROR_CODES.ROUND_NOT_FOUND]: {
        type: MESSAGE_TYPES.ERROR,
        content: {
            msg: { "$translate": "round_not_found" }
        },
        buttons: {
            ok: {
                msg: { "$translate": "close_game" },
                event: MESSAGE_EVENTS.MESSAGE_CLOSE_GAME
            }
        }
    }
};
